<template>
  <b-select
    v-model="buffer"
    v-validate="'required'"
    @input="$emit('input', buffer)"
    expanded
  >
    <option v-for="(cl, index) of entityClasses" :key="index" :value="cl">
      {{ cl }}
    </option>
  </b-select>
</template>

<script>
import { getEntityClasses } from '@/models/core'

export default {
  name: 'EntityClasses',
  inject: ['$validator'],
  props: {
    value: Object
  },
  data () {
    return {
      buffer: this.value
    }
  },
  computed: {
    entityClasses: function () {
      return Object.keys(getEntityClasses())
    }
  },
  watch: {
    value: {
      handler () {
        this.buffer = this.value
      },
      deep: true
    }
  }
}
</script>
